import { useLanguage } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Languages } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Category / subcategory + factory + duty / tax rebate + buyer / seller +
// 中文描述 (with auto-translate button — moved here 2026-02 v3 per user swap
// with MATERIAL which relocated to Row 3 right).
export const ClassificationFields = ({ form, setField, options, factories = [], onTranslate, translating = false, fieldEditable = () => true }) => {
  const { t } = useLanguage();

  return (
    <>
      {/* Row A (2026-02 v5): 6-col grid so 采购 · 外销 · 类别 · 子类别 · 工厂 · 退税率
          ALL fit in the same row. 采购/外销/退税率 are naturally narrower now.
          MOQ + 关税 have moved up to Row 3 right (see ProductForm.jsx). */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-3">
        <div className="space-y-1.5">
          <Label>{t("products.buyer")}</Label>
          <Select value={form.buyer || ""} onValueChange={(v) => setField("buyer", v)} disabled={!fieldEditable("buyer")}>
            <SelectTrigger data-testid="product-buyer-select">
              <SelectValue placeholder={t("products.select")} />
            </SelectTrigger>
            <SelectContent>
              {(form.buyer && !options.buyers.includes(form.buyer) ? [form.buyer, ...options.buyers] : options.buyers).map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>{t("products.seller")}</Label>
          <Select value={form.seller || ""} onValueChange={(v) => setField("seller", v)} disabled={!fieldEditable("seller")}>
            <SelectTrigger data-testid="product-seller-select">
              <SelectValue placeholder={t("products.select")} />
            </SelectTrigger>
            <SelectContent>
              {(form.seller && !options.sellers.includes(form.seller) ? [form.seller, ...options.sellers] : options.sellers).map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        {[
          ["category", "products.category", options.categories],
          ["subcategory", "products.subcategory", options.subcategories],
        ].map(([field, labelKey, opts]) => (
          <div key={field} className="space-y-1.5">
            <Label>{t(labelKey)}</Label>
            <Input
              list={`${field}-options`}
              value={form[field] || ""}
              placeholder={t("products.typeOrSelect")}
              onChange={(e) => setField(field, e.target.value)}
              data-testid={`product-${field}-input`}
              disabled={!fieldEditable(field)}
            />
            <datalist id={`${field}-options`}>
              {opts.map((o) => <option key={o} value={o} />)}
            </datalist>
          </div>
        ))}
        <div className="space-y-1.5">
          <Label>{t("products.factory")}</Label>
          <Select value={form.factory || "__none__"} onValueChange={(v) => setField("factory", v === "__none__" ? "" : v)} disabled={!fieldEditable("factory")}>
            <SelectTrigger data-testid="product-factory-select">
              <SelectValue placeholder={t("products.select")} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__none__">-</SelectItem>
              {factories.map((f) => <SelectItem key={f} value={f}>{f}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>{t("products.taxRebate")}</Label>
          <Input
            type="number"
            step="0.01"
            value={form.tax_rebate ?? 0.13}
            onChange={(e) => setField("tax_rebate", parseFloat(e.target.value) || 0)}
            data-testid="product-tax-rebate-input"
            disabled={!fieldEditable("tax_rebate")}
          />
        </div>
      </div>
    </>
  );
};
